<template>
    <div class="float-left mr-1">
        <b-button
            variant="primary"
            @click.stop="abrirModalComissionamentoForm()"
            v-if="$temAcessoView('API-COMISSOES-00')"
        >
            <span> <i class="fa fa-plus mr-2"></i> Nova Comissão</span>
        </b-button>

        <comissionamento-form
            @fecharModal="fecharModalComissionamentoForm()"
            @salvar="inserirComissao($event)"
            :exibir="display"
            :erros="erros"
            :contratos="contratos"
            acao="INSERÇÃO"
            :contrato="contrato"
        ></comissionamento-form>
    </div>
</template>

<script>
import ComissionamentoForm from './ComissionamentoForm.vue'
import ComissionamentosServicos from './comissionamentosServicos'
import ContratosServicos from '../ContratosServicos'
export default {
    components: {
        ComissionamentoForm
    },

    props: {
        comissionamento: {
            type: Object,
            default: () => ({})
        },
    },

    emits: ['obterNovasComissoes'],

    data() {
        return {
            display: false,
            erros: [],
            contratos: [],
            contrato: null
        }
    },

    methods: {
        abrirModalComissionamentoForm() {
            this.display = true

            this.obterContratos()
            this.obterContrato()
        },
        fecharModalComissionamentoForm() {
            this.display = false
        },
        inserirComissao(data) {
            this.$store.dispatch('addRequest')
            ComissionamentosServicos.inserirComissao(
                this.$route.params.contratoId,
                data
            ).then((response) => {
                if (response && response.success) {
                    this.$toast.success(
                        'Registro salvo com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    )
                    this.fecharModalComissionamentoForm()
                    this.$emit('obterNovasComissoes')
                } else {
                    this.erros = response.erros
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterContratos() {
            let filtro = {
                apenasAtivos: true
            }

            this.$store.dispatch('addRequest')

            ContratosServicos.obterTodos(filtro).then((response) => {
                if (response && response.success) {
                    this.contratos = response.data
                }
                this.$store.dispatch('removeRequest')
            })
        },
        obterContrato(){
            this.$store.dispatch('addRequest')

            ContratosServicos.obterPorId(this.$route.params.contratoId).then((response) => {
                if(response && response.success){
                    this.contrato = response.data
                }

                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
